module.exports = __webpack_public_path__ + "static/media/parede v3.18bd75ad.glb";